<template>
  <div class="edit_page">
    <div class="edit_wrapper"></div>
    <div class="edit">
      <div class="edit_top">
        <div class="edit_top_buttons">
          <input
            type="button"
            :value="cancelButton"
            class="cancel_button"
            @click="cancel"
          />
          <input
            type="button"
            :value="finishButton"
            class="finish_button"
            @click="update"
          />
        </div>
      </div>
      <div class="detail">
        <div class="detail_contents">
          <div class="detail_content">
            <div class="detail_label">
              {{ titleLabel }}
              <div class="require_items_label">
                {{ requiredItemLabel }}
              </div>
            </div>
            <input
              class="detail_input_field"
              type="text"
              v-model="template.title"
              @input="inputUpdate('title')"
            />
          </div>
          <div class="detail_content">
            <div class="detail_label">
              {{ templateLabel }}
              <div class="require_items_label">
                {{ requiredItemLabel }}
              </div>
            </div>
            <textarea
              id="message"
              class="detail_input_field message"
              v-model="template.message"
              @input="inputUpdate('message')"
            ></textarea>
          </div>
        </div>
      </div>
      <div class="edit_bottom">
        <input
          type="button"
          :value="deleteButton"
          class="edit_delete_button"
          @click="showModal = true"
        />
      </div>
      <div class="modalWindow" v-if="showModal">
        <modalWindow
          :question="deleteWord"
          :router="router"
          @close="stayClose"
          @remove="remove"
        >
        </modalWindow>
      </div>
      <div class="complete_modal_window" v-if="showCompleteModal">
        <completeModalWindow :question="completeWord" @close="close">
        </completeModalWindow>
      </div>
      <div class="complete_modal_window" v-if="showFailureModal">
        <completeModalWindow :question="failureWord" @close="stayClose">
        </completeModalWindow>
      </div>
      <div class="loading_modal_window" v-if="showloadingModal">
        <loadingModalWindow @close="close"> </loadingModalWindow>
      </div>
    </div>
  </div>
</template>

<script>
import modalWindow from '../modalWindow/detailDeleteModalWindow.vue'
import completeModalWindow from '../modalWindow/finishModalWindow.vue'
import loadingModalWindow from '../modalWindow/loadingModalWindow.vue'

export default {
  data() {
    return {
      cancelButton: 'キャンセル',
      finishButton: '完了',
      deleteButton: 'この情報を削除',
      titleLabel: 'タイトル',
      templateLabel: '定型文',
      router: '/template',
      deleteWord: 'この情報を削除してよろしいですか？',
      completeWord: '',
      failureWord: '',
      showModal: false,
      showCompleteModal: false,
      showloadingModal: false,
      showFailureModal: false
    }
  },
  computed: {
    template() {
      return this.$store.state.template.template
    },
    errorMsg() {
      return this.$store.state.error.errorMsg
    },
    requiredItemLabel() {
      return this.$store.state.error.requiredItemLabel
    }
  },
  components: {
    modalWindow,
    completeModalWindow,
    loadingModalWindow
  },
  methods: {
    inputUpdate(e) {
      this.$store.dispatch('template/inputUpdate', {
        name: e,
        value: event.target.value
      })
    },
    async cancel(e) {
      this.showloadingModal = true
      try {
        await this.$store.dispatch(
          'template/setDetailTemplate',
          this.$store.state.template.template
        )
        this.$router.push('../template/detail')
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_710001
        let eventType = 3
        let reason = 'MSGCRC0308'
        if (error.response) {
          this.failureWord =
            this.errorMsg.MSGCRC0308.name +
            this.errorMsg.MSGCRC0308.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        reason = 'MSGCRC0005'
        eventType = 9
        this.failureWord =
          this.errorMsg.MSGCRC0005.name +
          this.errorMsg.MSGCRC0005.value +
          'エラーコード：{' +
          eventNumber +
          '}'
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFailureModal = true
      }
      this.showloadingModal = false
    },
    async update(e) {
      this.showloadingModal = true
      try {
        await this.$store.dispatch('template/updateTemplate')
        this.$emit('list-reload')
        if (location.pathname !== '/template/detail') {
          this.$router.push('../template/detail')
        }
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_710001
        let eventType = 3
        let reason = ''
        if (
          error.response &&
          error.response.data &&
          error.response.data.header &&
          error.response.data.header.message
        ) {
          let errorMessage = error.response.data.header.message
          switch (errorMessage) {
            case 'MSGCRC0303':
            case 'MSGCRC0304':
            case 'MSGCRC0305':
            case 'MSGCRC0306':
              this.failureWord =
                this.errorMsg[errorMessage].name +
                this.errorMsg[errorMessage].value +
                'エラーコード：{' +
                eventNumber +
                '}'
              break
            default:
              this.failureWord =
                this.errorMsg.MSGCRC0309.name +
                this.errorMsg.MSGCRC0309.value +
                'エラーコード：{' +
                eventNumber +
                '}'
              break
          }
          reason = errorMessage + ' '
          reason += error.response.status
        } else if (error.response && error.response.data) {
          reason = 'MSGCRC0309'
          eventType = 9
          this.failureWord =
            this.errorMsg.MSGCRC0309.name +
            this.errorMsg.MSGCRC0309.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.failureWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFailureModal = true
        this.showloadingModal = false
        return
      }
      try {
        await this.$store.dispatch(
          'template/setDetailTemplate',
          this.$store.state.template.template
        )
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_710001
        let eventType = 3
        let reason = 'MSGCRC0308'
        if (error.response) {
          this.failureWord =
            this.errorMsg.MSGCRC0308.name +
            this.errorMsg.MSGCRC0308.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.failureWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFailureModal = true
      }
      this.showloadingModal = false
    },
    close(e) {
      this.showModal = false
      this.showCompleteModal = false
      this.$router.push(this.router)
    },
    stayClose(e) {
      this.showModal = false
      this.showCompleteModal = false
      this.showFailureModal = false
    },
    async remove(e) {
      this.showloadingModal = true
      let templateId = this.$store.state.template.template.id
      try {
        await this.$store.dispatch('template/deleteTemplates', [templateId])
        this.$emit('list-reload')
        this.showModal = false
        this.completeWord = '削除しました。'
        this.showCompleteModal = true
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_710001
        let eventType = 3
        let reason = 'MSGCRC0310'
        if (error.response) {
          this.failureWord =
            this.errorMsg.MSGCRC0310.name +
            this.errorMsg.MSGCRC0310.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.failureWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showModal = false
        this.showFailureModal = true
      }
      this.showloadingModal = false
    }
  }
}
</script>
<style scoped>
.message {
  resize: vertical;
  min-height: 100px;
  overflow-wrap: anywhere;
  white-space: pre-line;
  word-break: break-word;
}
</style>



// WEBPACK FOOTER //
// src/components/template/templateEdit.vue